var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/financialAidIndicator";
export default class FinancialAidIndicatorService {
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            return FinancialAidIndicatorService.search({
                ids,
                active: true,
            });
        });
    }
    static search(search = {}, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            name: search.name,
            value: search.value,
            active: search.active,
            ids: search.ids,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        });
    }
}
